import settings from '@/api/apiSferest/services/settings'
import examples from '@/api/apiSferest/services/examples'

export const set = ({ commit, dispatch, state }, payload) => {
  return new Promise((resolve, reject) => {
    if (!payload.xsltfile) payload.xsltfile = { name: null, file: null }
    if (!payload.logofile) payload.logofile = { name: null, file: null }
    commit('SET_NAME', payload.xsltfile.name)
    commit('SET_LOGO', payload.logofile.file)
    commit('SET_FORMAT', payload.format)
    commit('SET_PDF_FORMAT', payload.pdftemplate)
    commit('SET_OWNER_FORMAT', payload.xsltfile.file)
    resolve()
  })
}

export const get = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    settings.get(['format', 'pdftemplate', 'logofile', 'xsltfile'])
    .then((res) => {
      dispatch('set', res.data)
      .then(config => resolve(config))
    })
    .catch((e) => {
      reject(new Error(e))
    })
    resolve()
  })
}

export const downloadInvoiceExample = ({ commit, dispatch }) => {
  return new Promise((resolve, reject) => {
    examples.get('invoice')
    .then((res) => {
      let example = res.data
      if (example && example.file) {
        var link = document.createElement('a')
        link.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(example.file))
        link.setAttribute('download', example.name ? example.name : 'ejemplo.pdf')
        document.body.appendChild(link)
        link.click()
      }
      resolve()
    })
  })
}

export const saveFormat = ({commit, getters}, payload) => {
  return new Promise((resolve, reject) => {
    let params = getters['apificate'](payload)
    settings.update(payload, params)
    .then((res) => {
      resolve()
    })
  })
}

export const cleanState = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_NAME', null)
    commit('SET_LOGO', null)
    commit('SET_FORMAT', null)
    commit('SET_PDF_FORMAT', null)
    commit('SET_OWNER_FORMAT', null)
    commit('SET_LOGOFILENAME', null)
    resolve()
  })
}
